import { MessagesActions } from './types';
export const setExtensionMessage = (message) => async (dispatch) => {
    dispatch({
        type: MessagesActions.SEND_EXTENSION_MESSAGE,
        payload: message,
    });
    dispatch({ type: MessagesActions.REMOVE_EXTENSION_MESSAGE });
};
